<template>
	<v-card flat class="mx-auto storage-menu">
		<v-card-text class="pa-0">
			<v-row class="ma-0">
				<v-col v-if="storageStats" cols="12" class="pa-0 pb-2 storage-state">
					<v-row class="ma-0" justify="center">
						<label class="page-body font-weight-bold" style="color: #0b4073;">
							File Storage
						</label>
					</v-row>
					<v-row class="ma-0 py-2">
						<v-progress-linear height="10" :color="rateColor" background-color="#B9D1EC" rounded
							:value="storageStats.rate"></v-progress-linear>
					</v-row>
					<v-row class="ma-0 page-body font-weight-bold" justify="center"
						style="color: #0b4073; font-size: 15px;">
						{{ storageStats.rate }}% of
						{{ $helpers.bytesToFormattedSize(storageStats.max, 0, 'GB') }} used
					</v-row>
				</v-col>
				<v-col v-if="isMerchantPlanGroup && myPlan && myPlan.advertising.max_merchant_listings" cols="12"
					class="pa-0 storage-state">
					<v-row class="ma-0" justify="center">
						<label class="page-body" style="color: #0b4073; font-size: 15px;">
							Businesses:&nbsp;
						</label>
						<span class="page-body font-weight-bold" style="color: #0b4073; font-size: 15px;">
							{{ myPlan.advertising.max_merchant_listings }}
						</span>
					</v-row>
				</v-col>
				<v-col v-if="seatCount > 0" cols="12"
					class="pa-0 storage-state">
					<v-row class="ma-0" justify="center">
						<label class="page-body" style="color: #0b4073; font-size: 15px;">
							MyBREB Boards:&nbsp;
						</label>
						<span class="page-body font-weight-bold" style="color: #0b4073; font-size: 15px;">
							{{ seatCount }} locations
						</span>
					</v-row>
				</v-col>
				<v-col v-if="myPlan" cols="12" class="pa-0 storage-state">
					<v-row class="ma-0" justify="center">
						<label class="page-body" style="color: #0b4073; font-size: 15px;">
							Postings/Listings:&nbsp;
						</label>
						<span class="page-body font-weight-bold" style="color: #0b4073; font-size: 15px;">
							{{ selfListingsResponse ? selfListingsResponse.totalElements : 0 }} of
							{{ myPlan.posting.listing_limit }} used
						</span>
					</v-row>
					<!-- <v-row class="ma-0" justify="center">
						<label class="page-body" style="color: #0b4073;">
							Video Streaming:
						</label>
					</v-row> -->
					<v-row v-if="storageStats" class="ma-0 pt-1 page-body font-weight-bold" justify="center"
						align="center" style="color: #0b4073; font-size: 15px;">
						<v-icon :color="hasVideoPermission ? 'green' : 'grey'" size="25" class="pr-1">
							{{ hasVideoPermission ? 'mdi-check-circle' :
								'mdi-checkbox-blank-circle-outline' }}
						</v-icon>
						{{ hasVideoPermission ? storageStats.allowed_video_quality === 'ALLOW_4K_VIDEO' ?
							'4K Video Posting' : '1080p HD Video Posting' : 'Video Posting' }}
					</v-row>
				</v-col>
				<v-col cols="12" class="pa-0 add-storage">
					<v-divider class="ma-2" />
					<v-row v-if="!isMenuBar" class="ma-0 page-subtitle-left text-center" justify="center">
						Need More Storage Space?
					</v-row>
					<v-row v-if="!isMenuBar" class="ma-0 page-subtitle-left text-center" justify="center">
						Upgrade Your Account Today!
					</v-row>
					<v-row class="ma-0" justify="center">
						<!-- <v-col cols="12" class="pa-0 py-2">
							<v-select v-model="selectedPackage" :items="regularPlans" hide-details outlined dense
								placeholder="Get More Storage" style="border: 1px solid #0b4073;" :menu-props="{
									offsetY: true,
									position: 'bottom',
									allowOverflow: true,
									attach: true,
									// maxHeight: '400px',
								}" attach>
								<template v-slot:selection="{ item }">
									<v-card flat outlined width="100%" class="my-1"
										style="border: 1px solid black; background-color: #f5f5f5;">
										<v-row style=" color: #0b4073;" class="ma-0 page-body font-weight-bold">
											{{ item.nickname }}
										</v-row>
										<v-row class="ma-0 page-body">
											{{ item.posting.listing_limit + ' Postings/Listings + 1080p Video' }}
										</v-row>
										<v-row style="color: red;" class="ma-0 page-body font-weight-bold">
											Only {{ $helpers.priceFormat(item.prices[0].price_in_cents / 12,
												item.prices[0].currency_code) }}/mth
										</v-row>
									</v-card>
								</template>
<template v-slot:item="{ item }">
									<v-card flat outlined width="100%" class="my-1"
										style="border: 1px solid black; background-color: #f5f5f5;">
										<v-row style="color: #0b4073;" class="ma-0 page-body font-weight-bold">
											{{ item.nickname }}
										</v-row>
										<v-row class="ma-0 page-body">
											{{ item.posting.listing_limit + ' Postings/Listings + 1080p Video' }}
										</v-row>
										<v-row style="color: red;" class="ma-0 page-body font-weight-bold">
											Only {{ $helpers.priceFormat(item.prices[0].price_in_cents / 12,
												item.prices[0].currency_code) }}/mth
										</v-row>
									</v-card>
								</template>
<template v-slot:append>
									<v-icon color="black">mdi-menu-down</v-icon>
								</template>
</v-select>
</v-col> -->
						<v-col cols="12" class="pa-0 text-center">
							<BrebBtn backgroundColor="green" @click="clickGetMoreStorage">
								GET MORE STORAGE
							</BrebBtn>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-card-text>
		<BrebLoading :loading="loading" isComponent />
	</v-card>
</template>

<script>
import BrebBtn from "@/components/accessory/BrebBtn.vue"
import BrebLoading from '@/components/accessory/BrebLoading.vue';

export default {
	name: "StoragePlan",
	components: {
		BrebBtn,
		BrebLoading,
	},
	mixins: [],
	props: {
		isMenuBar: {
			type: Boolean,
			default: false
		},
	},
	data: function () {
		return {
			loading: false,
			// selectedPackage: null,
		}
	},
	computed: {
		mobile() {
			return this.$vuetify.breakpoint.mobile
		},
		cellphone() {
			return this.$vuetify.breakpoint.xs
		},
		user() {
			return this.$store.getters['user/getUser'];
		},
		isMerchant() {
			return this.$helpers.hasMerchantCreate(this.$store);
		},
		isAppliedMerchant() {
			return this.user?.merchantApplication;
		},
		myPlan() {
			return this.$store.getters['api/plan/getMyPlan'];
		},
		isMerchantPlanGroup() {
			return this.myPlan?.plan?.plan_group && this.myPlan.plan.plan_group === 'MERCHANT';
		},
		storageStats() {
			return this.$store.getters["api/file/getStats"];
		},
		hasVideoPermission() {
			return this.myPlan?.storage.allowed_video_quality && this.myPlan.storage.allowed_video_quality !== "ALLOW_NONE";
		},
		rateColor() {
			if (this.storageStats.rate && this.storageStats.rate > 80) {
				return "red";
			} else if (this.storageStats.rate && this.storageStats.rate > 60) {
				return "#ffeb3b";
			} else {
				return "#4caf50";
			}
		},
		regularPlans() {
			return this.$store.getters["api/plan/getPublicPlanByGroup"]({ group: 'REGULAR' });
		},
		seatCount() {
			return this.$store.getters["api/listings/getActiveSeats"]?.length || 0;
		},
		selfListingsResponse() {
			return this.$store.getters["api/listings/getSelfListingsResponse"];
		},
	},
	watch: {

	},
	methods: {
		clickGetMoreStorage() {
			if (this.$route.path !== '/dashboard/plan-subscription') {
				this.$router.push({ path: '/dashboard/plan-subscription', query: { addingAddon: true } });
			}
		}
	},
	created() {

	},
	beforeMount() {

	},
	mounted() {
		this.$store.dispatch("api/listings/requestSelfListingsAll");
	},
	beforeDestroy() {

	},

}
</script>

<style scoped>
.v-input>>>input {
	text-align: center;
	padding-left: 24px;
}
</style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@import 'node_modules/vuetify/src/styles/settings/variables';
@import "src/globals";
@media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {}

.storage-menu {

.storage-state {}

.add-storage {}
}
</style>